import { NextDoorEvent } from './nextDoorTypes';
import { trackNextDoorEvent } from './trackNextDoorEvent';

/**
 * Track a next door page view event
 */
export function trackNextDoorPageView(): void {
  trackNextDoorEvent(NextDoorEvent.PAGEVIEW);
}
